export default "__VITE_ASSET__VtHk9ssV__"